import type { ITagRequest } from "@/types"
import { axios } from "@/axios"

export async function deleteTags(tagRequest: ITagRequest, eventVaultId?: number) {
  if (!eventVaultId)
    throw new Error("Missing Event Vault Id: Unable to call `deleteTags`.")

  const response = await axios.delete(`api/${eventVaultId}/tags/removetag`, {
    data: tagRequest,
  })

  return response.data?.Message
}
